import ratmService from "./RATMService"

const searchRolesAndAssignments = (event: { target: { value: string | null } }) => {

    const { manageState, searchRolesAndAssignmentsKeys, rolesAndAssignmentsCopy } = ratmService

    //@ts-ignore
    const input = event.target.value.trim().toLowerCase()

    if (input) {
        let filtered = rolesAndAssignmentsCopy.filter(raa => {
            let concatenatedKeys = searchRolesAndAssignmentsKeys
                //@ts-ignore
                .map(key => raa.Role[key] ? raa.Role[key] : "")
                .join(" ")
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase()

            return concatenatedKeys.includes(input)
        });

        manageState([
            { key: "rolesAndAssignments", value: filtered },
            { key: "searchInput", value: event.target.value }
        ])
    } else {
        manageState([
            { key: "rolesAndAssignments", value: rolesAndAssignmentsCopy },
            { key: "searchInput", value: event.target.value }
        ])
    }
}

export default searchRolesAndAssignments